import makeStyles from "@material-ui/core/styles/makeStyles";
import { DisbursementStatus } from "Shared/types/Disbursements";

const useStyles = makeStyles((theme) => ({
  filename: {
    wordBreak: "break-all",
  },
  status: ({ status }: { status: string }) => ({
    color: status === DisbursementStatus.failed
      ? theme.palette.error.main
      : theme.palette.text.primary,
  })
}));

export default useStyles;
